import { inject } from '@angular/core';
import { CanActivateFn, Router, Routes } from '@angular/router';

import { AboutComponent } from './about/about.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { ConfigurationComponent } from './main/configuration/configuration.component';
import { MainComponent } from './main/main.component';
import { ResultsComponent } from './main/results/results.component';
import { AccountService } from './main/shared/services/account.service';

const requireAuthenticationGuard: CanActivateFn = (_, state) => {
  const accountService = inject(AccountService);
  const router = inject(Router);

  if (accountService.getActiveAccount()) {
    return true;
  }

  return router.createUrlTree(['/login']);
};

const redirectIfAuthenticatedGuard: CanActivateFn = () => {
  const accountService = inject(AccountService);
  const router = inject(Router);

  if (accountService.getActiveAccount()) {
    return router.createUrlTree(['/main']);
  }

  return true;
};

export const routes: Routes = [
  { path: 'login', component: LoginPageComponent, canActivate: [redirectIfAuthenticatedGuard] },
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: '',
    canActivateChild: [requireAuthenticationGuard],
    children: [
      {
        path: 'main',
        component: MainComponent,
        children: [
          // Default to configuration page when navigating to /main
          { path: '', pathMatch: 'full', redirectTo: 'configuration' },
          { path: 'configuration', component: ConfigurationComponent },
          { path: 'results', component: ResultsComponent }
        ]
      },
      { path: 'about', component: AboutComponent }
    ]
  },
  { path: '**', redirectTo: 'login' }
];
